import { styled, Box } from '@mui/material';

export const IntegrationsSectionStoresContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0),
}));
